import React from 'react'
import {
  Box,
  Typography,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material'
import { StadsprognoseFormData, StadsprognoseConfig } from '../../../types/stadsprognoseTypes'

interface Props {
  formData: StadsprognoseFormData
  onChange: (updates: Partial<StadsprognoseFormData>) => void
  config: StadsprognoseConfig | null
}

const aannameOptions = [
  { value: '3', label: 'Gemiddelde laatste 3 jaren' },
  { value: '5', label: 'Gemiddelde laatste 5 jaren' },
  { value: '10', label: 'Gemiddelde laatste 10 jaren' },
  { value: 'all', label: 'Gemiddelde van alle jaren' },
  { value: 'last', label: 'Laatste Jaar' },
]

const aannameFields: { key: keyof StadsprognoseFormData; label: string }[] = [
  { key: 'aanname_geb', label: 'Selecteer aanname voor geboorte' },
  { key: 'aanname_ste', label: 'Selecteer aanname voor sterfte' },
  { key: 'aanname_ves', label: 'Selecteer aanname voor vestiging' },
  { key: 'aanname_ver', label: 'Selecteer aanname voor vertrek' },
]

const Step2Stroomgegevens: React.FC<Props> = ({ formData, onChange, config }) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>Aannames stroomgegevens</Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
        Alle velden (m.u.v. externe prognose) zijn verplicht.
      </Typography>

      <Grid container spacing={2}>
        {aannameFields.map(({ key, label }) => (
          <Grid item xs={12} key={key}>
            <FormControl fullWidth size="small">
              <InputLabel>{label}</InputLabel>
              <Select
                value={formData[key] as string}
                label={label}
                onChange={(e) => onChange({ [key]: e.target.value })}
              >
                {aannameOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ))}

        <Grid item xs={12}>
          <FormControl fullWidth size="small">
            <InputLabel>Selecteer een Externe Prognose</InputLabel>
            <Select
              value={formData.selected_ext_code}
              label="Selecteer een Externe Prognose"
              onChange={(e) => onChange({ selected_ext_code: e.target.value })}
            >
              <MenuItem value="">
                <em>(selecteer een code)</em>
              </MenuItem>
              {config?.ext_codes?.map((item) => (
                <MenuItem key={item.code} value={item.code}>
                  {`${item.code}: ${item.naam ?? item.code}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Step2Stroomgegevens
